import { useListHoldings, useListOrders } from '@/trading/tradingQueries'

export const usePreloadPortfolio = (accountId: string | null, enabled: boolean, params: any) => {
    useListHoldings(accountId, { enabled })
    useListOrders(accountId, { enabled, ...params })
}
